

import ScrollToTop from "react-scroll-to-top";
const ScrollToTops = () => {
    return (
        <div>
            <div className="">
                <ScrollToTop
                    className="primary"
                    style={{ backgroundColor: "white" }}
                    smooth />
            </div>
        </div>
    )
}

export default ScrollToTops;